import {InfoModuleBasicState} from '@fantasmagames/slot/src/modules/hud/info/states/InfoModuleBasicState';

export class InfoModuleFreeSpinsState extends InfoModuleBasicState {
	public onEnterState(): void {
		super.onEnterState();
	}

	public onLeaveState(): void {
		super.onLeaveState();
	}

	protected setupEvents(): void {
		super.setupEvents();
	}

	protected onInitResponse(): void {
		this.updateBalance(this.module.logic.currentBalance);
		this.updateBet();
	}

	protected onAllReelsStopped(): void {

	}

	protected onSpinButtonPressed(): void {
	}

	protected onSpinButtonPressedNotEnoughMoney(): void {
	}

	protected onWinPresentationStopped(): void {
	}

	protected onSpinResponse(): void {

	}

	protected onWinNumberShownToPlayer(): void {
		this.updateData();
	}

	protected onInitialWinPresentationStarted(): void {
	}

	protected onWinCountupFinished(): void {
		this.updateData();
	}

	protected updateData(): void {
		const win = this.module.logic.freeSpinsTotalWin;
		this.updateWin(win);
	}

	protected onBigWinFinished(): void {
		this.updateData();
	}

	protected onNoWin(): void {
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/hud/info/states/InfoModuleFreeSpinsState.ts